module.exports = __webpack_public_path__ + "img/pocket side seam.c11e117d.png";